/**
 * 认证 API 服务
 */
import { api, API_PATHS, tokenManager } from './client';

// 登录请求
export interface LoginRequest {
  email: string;
  password: string;
}

// 用户信息
export interface AuthUserInfo {
  id: string;
  email: string;
  name: string;
  role: 'admin' | 'creator' | 'user';
  groups: string[];
  isActive: boolean;
}

// 组织信息
export interface OrgInfo {
  id: string;
  name: string;
  logo: string;
  banner: string;
  primaryColor: string;
  secondaryColor: string;
  welcomeMessage: string;
}

// 登录响应
export interface LoginResponse {
  token: string;
  user: AuthUserInfo;
  org: OrgInfo;
}

// 获取当前用户响应
export interface MeResponse {
  user: AuthUserInfo;
  org: OrgInfo;
}

/**
 * 登录
 */
export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  const response = await api.post<LoginResponse>(API_PATHS.AUTH_LOGIN, credentials);
  // 保存 token
  if (response.token) {
    tokenManager.set(response.token);
  }
  return response;
}

/**
 * 登出
 */
export async function logout(): Promise<void> {
  try {
    await api.post<null>(API_PATHS.AUTH_LOGOUT);
  } finally {
    // 无论成功失败都清除本地 token
    tokenManager.remove();
  }
}

/**
 * 获取当前用户信息
 */
export async function getCurrentUser(): Promise<MeResponse> {
  return api.get<MeResponse>(API_PATHS.AUTH_ME);
}

/**
 * 检查是否已登录
 */
export function isAuthenticated(): boolean {
  return tokenManager.isValid();
}
